const codeConfig = {
	scrambleInterval: 45,
	baseRevealDelay: 700,
	stepDelay: 350,
	jitter: 0,
	holdDuration: 200,
	fadeDuration: 500,
	charset:
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=._-',
}

export function createTickerState(phrases) {
	const initialState = {
		phraseIndex: 0,
		intervalId: null,
		phrases,
	}
	return initialState
}

export function animatePhrase({ codeEl, phrases, state }) {
	const targetPhrase = phrases[state.phraseIndex]
	const nowMs = performance.now()
	const letters = createLetterStates(targetPhrase, nowMs)

	codeEl.style.opacity = '1'
	stopInterval(state)

	const tick = () => {
		const timestampMs = performance.now()
		lockReadyLetters(letters, timestampMs)

		const firstUnlocked = letters.findIndex((letter) => !letter.locked)
		const allLocked = firstUnlocked === -1
		const nextOutput = buildOutput(letters, firstUnlocked, getRandomChar)

		codeEl.innerHTML = nextOutput

		if (allLocked) {
			stopInterval(state)
			setTimeout(
				() => handlePhraseComplete({ codeEl, phrases, state }),
				codeConfig.holdDuration
			)
		}
	}

	state.intervalId = setInterval(tick, codeConfig.scrambleInterval)
}

function handlePhraseComplete({ codeEl, phrases, state }) {
	codeEl.style.opacity = '0'
	const nextIndex = (state.phraseIndex + 1) % phrases.length
	state.phraseIndex = nextIndex
	setTimeout(
		() => animatePhrase({ codeEl, phrases, state }),
		codeConfig.fadeDuration
	)
}

export function parsePhrases(text = '') {
	const chunks = text.split('|')
	const trimmedChunks = chunks.map((chunk) => chunk.trim())
	return trimmedChunks.filter((chunk) => chunk !== '')
}

function createLetterStates(target, now) {
	const splitChars = target.split('')
	const baseDelay = codeConfig.baseRevealDelay
	const stepDelay = codeConfig.stepDelay
	const jitterRange = codeConfig.jitter

	return splitChars.map((char, idx) => {
		const letterIndex = idx
		const perLetterDelay = letterIndex * stepDelay
		const jitterOffset = Math.random() * jitterRange
		const totalDelay = baseDelay + perLetterDelay + jitterOffset
		const revealAt = now + totalDelay
		const letterState = { target: char, revealAt, locked: false }
		return letterState
	})
}

function lockReadyLetters(letters, timestamp) {
	for (const letter of letters) {
		const shouldLock = !letter.locked && timestamp >= letter.revealAt
		if (shouldLock) letter.locked = true
	}
}

function buildOutput(letters, firstUnlockedIndex, randomChar) {
	const renderedLetters = letters.map((letter, idx) => {
		const isLocked = letter.locked
		const isFirstUnlocked = idx === firstUnlockedIndex
		if (isLocked) return letter.target
		if (isFirstUnlocked) return randomChar()
		return ''
	})
	const wrappedLetters = renderedLetters.map((value) => {
		if (!value) return ''
		const span = `<span class="code-char">${value}</span>`
		return span
	})
	return wrappedLetters.join('')
}

function stopInterval(state) {
	if (state.intervalId) clearInterval(state.intervalId)
	state.intervalId = null
}

function getRandomChar() {
	const charsetLength = codeConfig.charset.length
	const randomIndex = Math.floor(Math.random() * charsetLength)
	const character = codeConfig.charset[randomIndex]
	return character
}
